import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M621.452,435.678 C621.452,248.82 773.456,96.8164 960.314,96.8164 C1119.63,96.8164 1253.62,207.32 1289.65,355.712 L724.351,1162.76 C660.918,1101.14 621.452,1014.98 621.452,919.766 L621.452,435.678 Z M668.286,1242.8 C580.118,1163.01 524.636,1047.74 524.636,919.767 L524.636,435.679 C524.636,195.475 720.111,0 960.315,0 C1137.27,0 1289.96,106.09 1358.09,257.997 L1538.8,0 L1631.18,64.6686 L333.381,1917.48 L241,1852.81 L546.287,1416.97 C414.414,1301.53 331,1132.02 331,943.411 L331,709.984 L427.818,709.984 L427.818,943.411 C427.818,1099.22 495.137,1239.65 602.21,1337.13 L668.286,1242.8 Z M960.314,1258.63 C950.927,1258.63 941.627,1258.24 932.431,1257.49 L870.36,1346.11 C899.396,1352.23 929.487,1355.45 960.315,1355.45 C1200.52,1355.45 1395.99,1159.97 1395.99,919.767 L1395.99,595.685 L1299.18,733.908 L1299.18,919.766 C1299.18,1106.62 1147.17,1258.63 960.314,1258.63 Z M797.318,1450.38 L739.603,1532.78 C793.897,1553.18 851.733,1566.28 911.908,1570.88 L911.908,1823.18 L669.861,1823.18 L669.861,1920 L1250.77,1920 L1250.77,1823.18 L1008.726,1823.18 L1008.726,1570.88 C1333.19,1546.08 1589.63,1274.12 1589.63,943.411 L1589.63,709.984 L1492.81,709.984 L1492.81,943.411 C1492.81,1236.96 1253.87,1475.91 960.315,1475.91 C903.491,1475.91 848.713,1466.95 797.318,1450.38 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMicOffLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMicOffLine, _Component);

  var _super = _createSuper(IconMicOffLine);

  function IconMicOffLine() {
    _classCallCheck(this, IconMicOffLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMicOffLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMicOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMicOffLine.displayName = "IconMicOffLine";
  return IconMicOffLine;
}(Component);

IconMicOffLine.glyphName = 'mic-off';
IconMicOffLine.variant = 'Line';
IconMicOffLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMicOffLine;
export { IconMicOffLine };